module.exports = __webpack_public_path__ + "img/help3-1-3.837af945.png";